import { MapperBase } from '../../utilities/mapper-base';
import { FilterResource } from '../resource/filter.resource';
import { Filter } from '../ui/filter.model';

export class FilterResourceToFilterMapper extends MapperBase<FilterResource, Filter> {
	map(source: FilterResource): Filter {
		const dest = new Filter();
		dest.savedFilterId = source.savedFilterId;
		dest.caseId = source.caseId;
		dest.createdById = source.createdById;
		dest.title = source.title;
		dest.dateTimeCreated = source.dateTimeCreated;
		dest.isPinned = source.isPinned;
		dest.isShared = source.isShared;
		dest.lifeCycle = source.lifeCycle;
		dest.filterXml = source.filterXml;
		dest.filterJson = source.filterJson;
		dest.filterJsonOld = source.filterJsonOld;
		dest.filterText = source.filterText;
		dest.error = source.error;
		return dest;
	}

}
